import { render } from "./ClienteEdit.vue?vue&type=template&id=35c546c6&scoped=true"
import script from "./ClienteEdit.vue?vue&type=script&lang=js"
export * from "./ClienteEdit.vue?vue&type=script&lang=js"

import "./ClienteEdit.vue?vue&type=style&index=0&id=35c546c6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35c546c6"]])

export default __exports__